import type { ReactNode } from 'react';
import { ArrowRight } from '../../components/ui/icons';
import { cn } from '../../lib/cn';

export function OnboardingButton({
  children,
  onClick,
  variant
}: {
  children: ReactNode;
  onClick: () => void;
  variant: 'dark' | 'green';
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'tap flex w-full items-center justify-center gap-[9px] rounded-[16px] py-[17px] text-[16px] font-extrabold tracking-snug text-white',
        variant === 'green'
          ? 'bg-[linear-gradient(140deg,#2EDB7B,#0BA078)] shadow-[inset_0_1px_0_rgba(255,255,255,0.35),0_18px_34px_-14px_rgba(36,197,106,0.6)]'
          : 'bg-night shadow-dark'
      )}
    >
      {children}
      <ArrowRight width={17} height={17} strokeWidth={variant === 'green' ? 2.6 : 2.4} />
    </button>
  );
}
